import React, { useEffect } from "react";
import { useOktaAuth } from "@okta/okta-react";
import { Outlet } from "react-router-dom";
import Header from "../../shared/header/header";
import BottomBar from "../../shared/bottomBar/bottomBar";
import { getApplicationConfig } from "../../constants/utilities";
import CheckAcknowledgment from "../../Acknowledgment";
function AuthRequired() {
    var _a = useOktaAuth(), oktaAuth = _a.oktaAuth, authState = _a.authState;
    useEffect(function () {
        if (!authState) {
            return;
        }
        if (!(authState === null || authState === void 0 ? void 0 : authState.accessToken)) {
            var application = getApplicationConfig();
            oktaAuth.setOriginalUri(application.vitePublicUrl);
            oktaAuth.signInWithRedirect();
        }
    }, [oktaAuth, !!authState, authState === null || authState === void 0 ? void 0 : authState.accessToken]);
    if (!authState || !(authState === null || authState === void 0 ? void 0 : authState.accessToken)) {
        return React.createElement("div", null, "Loading...");
    }
    return (React.createElement(CheckAcknowledgment, null,
        React.createElement("div", null,
            React.createElement(Header, null),
            React.createElement(Outlet, null),
            React.createElement(BottomBar, null))));
}
export default AuthRequired;
